import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import StepsAddCampaigns from "./StepsAddCampaigns";
import TitleBar from "../../partials/content/TitleBar";

function AllTypesCampaigns() {
  let items = [
    {
      title: "نوع کمپین",
      status: true,
      link: "/campaigns/all-type",
    },
    {
      title: "تنظیمات کمپین",
      status: false,
      link: "/campaigns/banner/add-simple",
    },
  ];
  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="نوع کمپین ها" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <StepsAddCampaigns items={items} />

              <div className="container-fluid" id="type-all-campaigns">
                <div className="row">
                  <div
                    className="col-12 col-sm-6 col-lg-3 pb-4 pb-sm-2 pb-lg-0 campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 d-flex flex-column justify-content-between  rounded h-100">
                      <div className="item-img text-center py-3">
                        <img
                          className="w-50"
                          src="/assets/img/campaign-banner.svg"
                        />
                      </div>
                      <div className="item-name text-center">
                        <b>بنری</b>
                      </div>
                      <div className="item-line">
                        <hr className="border border-top-1" />
                      </div>
                      <div className="item-list-data">
                        <ul className="m-0">
                          <li> افزایش آگاهی از برند</li>
                          <li> افزایش فروش کسب‌وکارها</li>
                          <li>جلب اعتماد میلیون ها کاربر</li>
                          <li>انتخاب سایت های نمایش دهنده</li>
                          <li>امکان گزارش گیری دقیق</li>
                          <li>مناسب کسب و کارهای مرتبط با صنعت و ساختمان</li>
                        </ul>
                      </div>
                      <div className="item-more-data py-4  text-center">
                        <Link
                          to="/campaigns/all-type-banner"
                          className="btn btn-success"
                        >
                          انتخاب
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-sm-6 col-lg-3 pb-4 pb-sm-2 pb-lg-0  campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 d-flex flex-column justify-content-between  rounded h-100">
                      <div className="item-img text-center py-3">
                        <img
                          className="w-50"
                          src="/assets/img/campaign-native.svg"
                        />
                      </div>
                      <div className="item-name text-center">
                        <b>همسان</b>
                      </div>
                      <div className="item-line">
                        <hr className="border border-top-1" />
                      </div>
                      <div className="item-list-data">
                        <ul className="m-0">
                          <li> ایجاد آگاهی از برند</li>
                          <li> افزایش ترافیک و جذب کاربر</li>
                          <li> افزایش ترافیک و جذب کاربر </li>
                          <li> انتخاب نمایش دهنده مناسب</li>
                          <li> امکان گزارش گیری دقیق</li>
                          <li> مناسب کسب و کارهای مرتبط با صنعت و ساختمان</li>
                        </ul>
                      </div>
                      <div className="item-more-data py-4  text-center">
                        {/* <Link
                          to="/campaigns/all-type-native"
                          className="btn btn-success"
                        >
                          انتخاب
                        </Link> */}
                        <span className="btn btn-secondary">به زودی</span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-sm-6 col-lg-3 pb-4 pb-sm-0 campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 d-flex flex-column justify-content-between  rounded h-100">
                      <div className="item-img text-center py-3">
                        <img
                          className="w-50"
                          src="/assets/img/campaign-push.svg"
                        />
                      </div>
                      <div className="item-name text-center">
                        <b>پوش</b>
                      </div>
                      <div className="item-line">
                        <hr className="border border-top-1" />
                      </div>
                      <div className="item-list-data">
                        <ul className="m-0">
                          <li> ایجاد آگاهی از برند</li>
                          <li> افزایش فروش کسب‌وکارها</li>
                          <li>ارسال لحظه به کاربران هدف</li>
                          <li> مناسب اطلاع رسانی های فوری</li>
                          <li> امکان گزارش گیری دقیق</li>
                          <li> هزینه به ازای ارسال به مخاطب</li>
                        </ul>
                      </div>
                      <div className="item-more-data py-4  text-center">
                        <span className="btn btn-secondary">به زودی</span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12 col-sm-6 col-lg-3 pb-4 pb-sm-0 campaign-item"
                    id="campaign-banner"
                  >
                    <div className="border border-1 d-flex flex-column justify-content-between  rounded h-100">
                      <div className="item-img text-center py-3">
                        <img
                          className="w-50"
                          src="/assets/img/campaign-product.svg"
                        />
                      </div>
                      <div className="item-name text-center">
                        <b>محصول</b>
                      </div>
                      <div className="item-line">
                        <hr className="border border-top-1" />
                      </div>
                      <div className="item-list-data">
                        <ul className="m-0">
                          <li>افزایش فروش کسب‌وکارها</li>
                          <li>بدون نیاز به ساخت تبلیغ</li>
                          <li>مناسب برای فروشگاه های آنلاین</li>
                          <li>بدون نیاز به ساخت تبلیغ</li>
                          <li>امکان گزارش گیری دقیق</li>
                          <li>انتخاب سایت های نمایش دهنده </li>
                        </ul>
                      </div>
                      <div className="item-more-data py-4  text-center">
                        <span className="btn btn-secondary">به زودی</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllTypesCampaigns;
